import { useState, useEffect, useCallback } from 'react';

const logisticsSlides = [
  {
    image: 'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/801dbd2458e1c90a84aceeb4cf7be4f6.png',
    title: 'Transporte de Cargas Pesadas',
    subtitle: 'Vigas y estructuras metálicas aseguradas profesionalmente',
  },
  {
    image: 'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/c1c12514035003b79fa6e15ee8e15e85.png',
    title: 'Carga y Aseguramiento',
    subtitle: 'Protocolos de seguridad en cada embarque',
  },
  {
    image: 'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/a3aed8d696f92549eeb82f1899e427fa.png',
    title: 'mULTIFIERROS',
    subtitle: 'Camiones propios para distribución local y regional',
  },
  {
    image: 'https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/824226265e865f285999f9194004a2bd.png',
    title: 'Trazabilidad de Productos',
    subtitle: 'Cada pieza identificada y documentada para entrega',
  },
];

export default function Logistics() {
  const [activeIndex, setActiveIndex] = useState(0);

  const activate = useCallback((index: number) => {
    setActiveIndex(index);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % logisticsSlides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="logistica" className="py-20 md:py-28 bg-background-50">
      {/* Header */}
      <div className="max-w-[1320px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-heading text-5xl md:text-7xl text-foreground-50 tracking-wide leading-tight">
            Nuestra Logística
          </h2>
          <p className="text-foreground-400 text-base md:text-lg max-w-3xl mx-auto mt-6 leading-relaxed">
            Disponemos de camiones propios para la distribución a nuestros clientes locales,
            complementado con una alianza estratégica con una empresa de transporte para las
            entregas a nivel regional.
          </p>
        </div>
      </div>

      {/* Connected Photo Grid */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="rounded-lg overflow-hidden">
          {/* Top row: panoramic photo */}
          <div className="relative group">
            <img
              src={logisticsSlides[0].image}
              alt={logisticsSlides[0].title}
              className="w-full h-[280px] md:h-[380px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <h3 className="font-heading text-white text-xl md:text-2xl tracking-wide">
                {logisticsSlides[0].title}
              </h3>
              <p className="text-white/70 text-sm mt-1">
                {logisticsSlides[0].subtitle}
              </p>
            </div>
          </div>

          {/* Bottom row: 3 vertical photos connected */}
          <div className="grid grid-cols-1 md:grid-cols-3">
            {logisticsSlides.slice(1).map((slide, idx) => (
              <div
                key={idx}
                className="relative group"
                onMouseEnter={() => activate(idx + 1)}
              >
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="w-full h-[360px] md:h-[480px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="font-heading text-white text-lg md:text-xl tracking-wide">
                    {slide.title}
                  </h3>
                  <p className="text-white/70 text-sm mt-1">
                    {slide.subtitle}
                  </p>
                </div>
                {/* Active indicator dot */}
                <div className="absolute top-4 right-4">
                  <div
                    className={`w-2.5 h-2.5 rounded-full transition-colors ${
                      activeIndex === idx + 1 ? 'bg-white' : 'bg-white/30'
                    }`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Progress bar */}
        <div className="flex mt-4 gap-1">
          {logisticsSlides.map((_, idx) => (
            <button
              key={idx}
              onClick={() => activate(idx)}
              className={`h-1 rounded-full transition-all duration-500 cursor-pointer ${
                activeIndex === idx ? 'bg-primary-500 flex-[2]' : 'bg-background-200 flex-1 hover:bg-background-300'
              }`}
              aria-label={`Ver ${logisticsSlides[idx].title}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}